/* eslint-disable */
import { h5, pc, help } from '@/config/config';
import { contentType } from '@/config/setting';
import { api } from '@/api/api';
import * as gqlApi from '@/api-gql/api';
import { msg, getEnv } from '@/utils/util';
import * as login from '@/utils/login';

export default {
  install(Vue, options) {

  	Vue.prototype.loginData = {
      test: {},
      pre: {},
      rel: {}
    };

    Vue.prototype.getLoginData = function() {
      switch (getEnv()) {
        case 'test':
          return this.loginData.test;
          break;
        case 'pre':
          return this.loginData.pre;
          break;
        case 'rel':
          return this.loginData.rel;
          break;
        default:

      }
    };

    Vue.prototype.setLoginData = function(data) {
      switch (getEnv()) {
        case 'test':
          this.loginData.test = data;
          break;
        case 'pre':
          this.loginData.pre = data;
          break;
        case 'rel':
          this.loginData.rel = data;
          break;
        default:
      }
    };

    Vue.prototype.logout = function() {

    };


  	Vue.prototype.msg = msg;


  	Vue.prototype.apiGet = function(type, key, params) {
      if (type == 'wwwHost') {
        return api.get(type, key, params);
      } else if (type == 'manageHost') {
        return api.get(type, key, params);
      } else if (type == 'gqlHost') {
        return gqlApi.api.query(key, params);
      }
      return Promise.reject({ error: 404, message: '当前接口不存在' });
  	};

  	Vue.prototype.apiPost = function(type, key, params) {
      if (type == 'wwwHost') {
        return api.post(type, key, params);
      } else if (type == 'manageHost') {
        return api.post(type, key, params);
      } else if (type == 'gqlHost') {
        return gqlApi.api.mutate(key, params);
      }
      return Promise.reject({ error: 404, message: '当前接口不存在' });
  	};
  	Vue.prototype.apiPut = function(type, key, params) {
      if (type == 'wwwHost') {
        return api.put(type, key, params);
      } else if (type == 'manageHost') {
        return api.put(type, key, params);
      } else if (type == 'gqlHost') {
        return gqlApi.api.mutate(key, params);
      }
      return Promise.reject({ error: 404, message: '当前接口不存在' });
  	};

  	Vue.prototype.apiDelete = function(type, key, params) {
      if (type == 'wwwHost') {
        return api.delete(type, key, params);
      } else if (type == 'manageHost') {
        return api.delete(type, key, params);
      }
      return Promise.reject({ error: 404, message: type + '当前接口域名不存在' });
  	};

    Vue.prototype.apiRequest = function(method, type, key, params) {
      switch (method) {
        case 'get':
          return this.apiGet(type, key, params);
          break;
        case 'post':
          return this.apiPost(type, key, params);
          break;
        case 'put':
          return this.apiPut(type, key, params);
          break;
        case 'delete':
          return this.apiDelete(type, key, params);
          break;
        default:
          return Promise.reject({ error: 404, message: method + '当前方法不存在' });
      }
    };

  	Vue.prototype.query = function(gqlQuery, params) {
      return gqlApi.api.query(gqlQuery, params);
  	};

  	Vue.prototype.mutate = function(gqlMutate, params) {
      return gqlApi.api.mutate(gqlMutate, params);
  	};

  	Vue.prototype.nextPage = function(page, pageSize) {
  		return window.btoa('arrayconnection:' + (((page - 1) * pageSize) - 1));
    };

  	Vue.prototype.sortIndex = function(index, page, size = 10) {
      return index + page * size - size + 1;
  	};

  	Vue.prototype.envType = function() {
  		const topHost = window.location.host.split('.')[0]
  	  if (topHost.indexOf('pre') != -1) {
  	    return 'pre'
  	  } else if (topHost.indexOf('test') != -1){
  	    return 'test'
  	  }
  	  const secHost = window.location.href.split('.')[1]
  	  if (secHost.indexOf('pre') != -1) {
  	    return 'pre'
  	  } else if (secHost.indexOf('test') != -1){
  	    return 'test'
  	  }
  	  return 'rel'
  	};

  	// Vue.prototype.setLoginData = function(data) {
  	// 	if (typeof data == 'string') {
  	// 		localStorage.setItem('loginData', this.unecption(data));
  	// 	} else {
  	// 		localStorage.setItem('loginData', this.unecption(JSON.stringify(data)));
  	// 	}
  	// };
    //
  	// Vue.prototype.getLoginData = function() {
  	// 	if (localStorage.getItem('loginData')) {
    //     try{
    //       return JSON.parse(this.unecption(localStorage.getItem('loginData')));
    //     } catch (e) {
    //       return '';
    //     }
  	// 	} else {
  	// 		return '';
  	// 	}
  	// };
    //
  	// Vue.prototype.setShopInfo = function(data) {
  	// 	if (typeof data == 'string') {
  	// 		localStorage.setItem('shopInfo', this.unecption(data));
  	// 	} else {
  	// 		localStorage.setItem('shopInfo', this.unecption(JSON.stringify(data)));
  	// 	}
  	// };
    //
  	// Vue.prototype.getShopInfo = function() {
  	// 	if (localStorage.getItem('shopInfo')) {
    //     try{
    //       return JSON.parse(this.unecption(localStorage.getItem('shopInfo')));
    //     } catch (e) {
    //       return '';
    //     }
  	// 	} else {
  	// 		return ''
  	// 	}
  	// };

  	Vue.prototype.matchShopVersion = function(version) {
  		if (!version && localStorage.getItem('shopInfo')) {
        version = localStorage.getItem('shopInfo') ? JSON.parse(localStorage.getItem('shopInfo')).version : '';
  		}
  		let ver = '';
  		switch (version) {
  			case 'basic':
  				ver = '基础版';
  				break;
  			case 'standard':
  				ver = '标准版';
  				break;
  			case 'advanced':
  				ver = '高级版';
  				break;
  			case 'unactive-partner':
  				ver = '合伙人版(未激活)';
  				break;
  			case 'partner':
  				ver = '合伙人版';
  				break;
  			default:
  		}
  		return ver;
  	};

  	Vue.prototype.verifyShopVersion = function(version) {
  		if (!version && localStorage.getItem('shopInfo')) {
  			version = localStorage.getItem('shopInfo') ? JSON.parse(localStorage.getItem('shopInfo')).version : '';
  		}
  		let ver = false;
  		switch (version) {
  			case 'basic':
  				ver = false;
  				break;
  			case 'standard':
  				ver = true;
  				break;
  			case 'advanced':
  				ver = true;
  				break;
  			case 'unactive-partner':
  				ver = false;
  				break;
  			case 'partner':
  				ver = true;
  				break;
  			default:
  				ver = false;
  		}
  		return ver;
  	};

  	Vue.prototype.getUserSource = function(source) {
      if (!source) {
        return '未知';
      }
      let changeSource = {
        'inner': '内部用户',
        'wechat': 'H5',
        'h5': 'H5',
        'applet': '小程序',
        'dingdone': '叮铛',
        'smartcity': "智慧城市",
        'app': 'APP端用户'
      }
      console.log('source: ', source);
      return changeSource[source] || '-';
  	};

  	Vue.prototype.getPayMentType = function(pay) {
      if (!pay) {
        return '未知';
      }
      let type = {
        '1': '支付购买',
        '2': '赠送领取',
        '3': '自建邀请码',
        '4': '免费订阅',
        '5': "会员卡免费订阅"
      }
      return type[pay];
  	};

  	Vue.prototype.getSubscribeWay = function(way) {
      if (!way) {
        return '未知';
      }
      let type = {
        'buy': '购买',
        'share_code': '领取赠送',
        'code': '赠送码',
        'sub': '购买',
        'member_card_sub': '会员免费',
        'application_subscribe': '申请加入',
        'related_content_subscribe': '关联购买',
        'admin_setting': '后台设置',
        'coin_exchange': '积分兑换'
      }
      return type[way];
  	};

  	Vue.prototype.getAppletSource = function(source, extra) {
      return source == 'applet' ?  ((extra && typeof extra == 'object' ? ('（' + extra.diy_name + '）' || '') : '') || '(未知)') : '';
  	};

  	Vue.prototype.getContentTypeName = function(type) {
      return contentType[type] || '未知';
  	};

  	Vue.prototype.getH5Host = function() {
  		let loginData = localStorage.getItem('loginData') ? JSON.parse(localStorage.getItem('loginData')) : '';
  		let shopInfo = localStorage.getItem('shopInfo') ? JSON.parse(localStorage.getItem('shopInfo')) : '';
  		if (loginData) {
  			if (this.envType() == 'rel' && shopInfo) {
          return shopInfo.h5_host + '/#/';
  			} else {
          return shopInfo.h5_host + '/#/';
  			}
  		} else {
  			return h5.host + '/';
  		}
  	};
  	Vue.prototype.getPcHost = function() {
  		let loginData = localStorage.getItem('loginData') ? JSON.parse(localStorage.getItem('loginData')) : '';
  		if (loginData) {
  			return `${pc.host}/${loginData.shop.id}/`;
  		}
  	};
  	Vue.prototype.timePickerOptions = function() {
  		let pickerOptions = {
  			shortcuts: [{
  				text: '最近一周',
  				onClick(picker) {
  					const end = new Date();
  					const start = new Date();
  					start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
  					picker.$emit('pick', [start, end]);
  				}
  			}, {
  				text: '最近一个月',
  				onClick(picker) {
  					const end = new Date();
  					const start = new Date();
  					start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
  					picker.$emit('pick', [start, end]);
  				}
  			}, {
  				text: '最近三个月',
  				onClick(picker) {
  					const end = new Date();
  					const start = new Date();
  					start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
  					picker.$emit('pick', [start, end]);
  				}
  			}]
  		};
  		return pickerOptions;
  	};
  	Vue.prototype.formatNumber = function(num, length) {
  		if (num || Number(num) === 0) {
  			return Number(num).toFixed(length);
  		} else {
  			return '';
  		}
  	};

    Vue.prototype.UNITS = {
  		'年': 31557600000,
  		'月': 2629800000,
  		'天': 86400000,
  		'小时': 3600000,
  		'分钟': 60000,
  		'秒': 1000
  	};

    Vue.prototype.formatCountTime = function (milliseconds) {
      var diff = milliseconds;

      let day = 0;
      let hour = 0;
      let min = 0;
      let sec = 0;
      let msec = 0;

      if (diff >= this.UNITS['天']) {
      	 day = Math.floor(diff / this.UNITS['天']);
         diff -= (day * this.UNITS['天']);
      }
      if (diff >= this.UNITS['小时']) {
      	hour = Math.floor(diff / this.UNITS['小时']);
        diff -= (hour * this.UNITS['小时']);
      }
      if (diff >= this.UNITS['分钟']) {
      	min = Math.floor(diff / this.UNITS['分钟']);
        diff -= (min * this.UNITS['分钟']);
      }
      if (diff >= this.UNITS['秒']) {
      	sec = Math.floor(diff / this.UNITS['秒']);
        diff -= (sec * this.UNITS['秒']);
      }
      msec = diff;

      var _format = function (number) {
      	return (number < 10 ? ('0' + number) : number);
      };

      if (milliseconds > 0) {

        var time = '';
        time += day ? _format(day) + '天' : '';
        time += _format(hour) + ':';
        time += _format(min) + ':';
        time += _format(sec);
        return time;
        // return _format(day) + '天' + _format(hour) + ':' + _format(min) + ':' + _format(sec) + ':' + _format(msec);
      } else{
      	return '00:00:00';
      }
    }
  	Vue.prototype.timePickerOptions = function() {
  		let pickerOptions = {
  			shortcuts: [{
  				text: '最近一周',
  				onClick(picker) {
  					const end = new Date();
  					const start = new Date();
  					start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
  					picker.$emit('pick', [start, end]);
  				}
  			}, {
  				text: '最近一个月',
  				onClick(picker) {
  					const end = new Date();
  					const start = new Date();
  					start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
  					picker.$emit('pick', [start, end]);
  				}
  			}, {
  				text: '最近三个月',
  				onClick(picker) {
  					const end = new Date();
  					const start = new Date();
  					start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
  					picker.$emit('pick', [start, end]);
  				}
  			}]
  		};
  		return pickerOptions;
  	};
  	Vue.prototype.formatTime = function(date, transform) {
  		if(!date){
  			return '';
  		} else if (typeof date == 'number') {
        if (String(date).length < 13) {
          date = new Date( date * 1000 );
        } else {
          date = new Date( date );
        }
  		} else if (isNaN(Date.parse(date))) {
  			date = new Date( Date.parse(date.replace(/-/g, "/")));
  		} else {
  			date = new Date( Date.parse(date) );
  		}

  		transform = transform || 'yyyy-MM-dd HH:mm:SS';

  		const mon = date.getMonth() + 1,
  					dd = date.getDate(),
  					hh = date.getHours(),
  					mm = date.getMinutes(),
  					ss = date.getSeconds();

  		const year = date.getFullYear(),
  					month = mon < 10 ? '0' + mon : mon,
  					day = dd < 10 ? '0' + dd : dd,
  					hour = hh < 10 ? '0' + hh : hh,
  					minute = mm < 10 ? '0' + mm : mm,
  					second = ss < 10 ? '0' + ss : ss;
  					transform = transform.replace('yyyy',year)
  					.replace('MM',month).replace('dd',day)
  					.replace('HH',hour).replace('mm',minute)
  					.replace('SS',second)
  					return transform;
  	};

  	// 拼接链接参数
  	Vue.prototype.stitchingParameters = function(url, params) {
  		let queryString = Object.entries(params)
  			.map((entry) => (entry[1] != undefined ? entry[0] + '=' + encodeURIComponent(entry[1]) : ''))
  			.filter((query) => query != '')
  			.join('&');
  		queryString = queryString === '' ? '' : '?' + queryString;
  		return url + queryString;
  	};

  	// 验证 http链接
  	Vue.prototype.urlTest = function(url) {
  		if (url.toString().indexOf('http://') < 0 && url.toString().indexOf('https://') < 0) {
  			url = 'http://' + url;
  		}
  		const reg = /^((http|https):\/\/(\w+:{0,1}\w*@)?(\S+)|)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?$/;
  		if (reg.test(url)) {
  			return url;
  		} else{
  			return -1;
  		}
  	};

  	// ^ 1 以数字1 开头
  	// [3-578] 手机号第二位允许是 3 、4 、5、7、8 中的任意一位
  	// \d{9} 任意9位数字组合
  	// $ 只能以数字作为结尾
  	Vue.prototype.isPhoneNumber = function(phone) {
  		var phoneReg = /^1[3-56789]\d{9}$/;
  		if (phoneReg.test(phone)) {
  			return true;
  		} else {
  			return false;
  		}
  	};

  	Vue.prototype.isOnlyNumber = function(val) {
  		var numberReg = /^\d+$/;
  		if (numberReg.test(val)) {
  			return true;
  		}
  		return false;
  	};

  	// "^\\d+$"　　//非负整数（正整数 + 0）
  	// "^[0-9]*[1-9][0-9]*$"　　//正整数
  	// "^((-\\d+)|(0+))$"　　//非正整数（负整数 + 0）
  	// "^-[0-9]*[1-9][0-9]*$"　　//负整数
  	// "^-?\\d+$"　　　　//整数
  	// "^\\d+(\\.\\d+)?$"　　//非负浮点数（正浮点数 + 0）
  	// "^(([0-9]+\\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\\.[0-9]+)|([0-9]*[1-9][0-9]*))$"　　//正浮点数
  	// "^((-\\d+(\\.\\d+)?)|(0+(\\.0+)?))$"　　//非正浮点数（负浮点数 + 0）
  	// "^(-(([0-9]+\\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\\.[0-9]+)|([0-9]*[1-9][0-9]*)))$"　　//负浮点数
  	// "^(-?\\d+)(\\.\\d+)?$"　　//浮点数

  	// 非负整数
  	Vue.prototype.isNonnegativeInteger = function(val) {
  		var numberReg = /^\d+$/;
  		if (numberReg.test(val)) {
  			return true;
  		}
  		return false;
  	};
  	Vue.prototype.isTwoDecimalNumber = function(val) {
  		// var numberReg = /([0-9]+.[0-9]{2})[0-9]*/;
  		var numberReg = /^(-?\d+)(\.\d{1,2})?$/;
  		if (numberReg.test(val)) {
  			return true;
  		}
  		return false;
  	};

  	// 字数转换成字符数：一个汉字一个字符，其他都是0.5个字符
  	Vue.prototype.getBytextLength = function(val) {
      if (!val) {
        return 0;
      }
      let len = 0;
      for (let i = 0; i < val.length; i++) {
        let code = val.charCodeAt(i);
        if (Number(code) > 255) {
          len += 1;
        } else {
          len += 0.5;
        }
      }
      return len;
  	};


    Vue.prototype.isNull = function(object, field) {
      if (object && typeof object == 'object') {
        if (object.hasOwnProperty(field)) {
          return false;
        }
        return true;
      } else {
        return true;
      }
    }

  	/*
  	 * 图片串接 createImgsrc
     https://cloud.tencent.com/document/product/460/6925#SF
  	 * */
   	Vue.prototype.createImgsrc = function(image, options={}) {
      if (!image) {
        return '';
      }
      var data = image;
      try{
        if (typeof image == 'object') {
          data = JSON.parse(JSON.stringify(image));
        }
      } catch(e) {
        console.log('createImgsrc: ', e);
        return '';
      }
      if (data && data.file && data.file.indexOf('.gif') != -1) {
        return data.host + data.file;
      }

  		var src, op_str = '';
      options.orient = true;
      options.type = options.type || 'imageMogr2';
      op_str = '?' + options.type;
      switch (options.type) {
        case 'imageView2':
          if (options.width || options.height){
            op_str += '/2/';
            if (options.width && options.height){
              op_str += ('w/' + options.width + '/h/' + options.height);
            } else if (options.width){
              op_str += ('w/' + options.width)
            } else if (options.height){
              op_str += ('h/' + options.height)
            }
          }
          break;
        case 'imageMogr2':
          if (options.orient) {
            op_str += '/auto-orient'
          }
          if (options.width || options.height) {
            op_str += '/thumbnail/';
            if (options.width && options.height) {
              op_str += (options.width + 'x' + options.height);
            } else if (options.width){
              op_str += (options.width + 'x')
            } else if (options.height){
              op_str += ('x' + options.height)
            }
          } else if (options.scale) {
            op_str += ('/thumbnail/!' + options.scale + 'p')
          }
          if(options.quality) {
            op_str += ('/quality/' + options.quality)
          }
          if (data.query) {
            data.query = data.query.replace('imageMogr2/auto-orient', '')
            op_str += data.query;
          }
          break;
      }

  	  if (!this.isNull(data, 'host')) {
        if (options.format && data.file.indexOf('.gif') == -1) {
          op_str += '/format/' + options.format;
        }
        // if (options.https && !data.host.startWith('http')) {
        //   data.host = 'https:' + data.host;
        // } else if (options.http) {
        //   data.host = data.host && data.host.replace(/(https:)/, 'http');
        // } else {
        //   data.host = data.host && data.host.replace(/(http:|https:)/, '');
        // }
  	    src = data.host + data.file + op_str;
  	    return src;
  	  } else if (typeof data == 'string') {
        return data.indexOf('.myqcloud.com') !== -1 ? (data + op_str) : data;
        // return data.indexOf('duanshu-1253562005.picsh.myqcloud.com') !== -1 ? (data + op_str) : data;
  	  }
  	  return '';
  	};


  	Vue.prototype.ecption = function(code){
  	// 	let c = String.fromCharCode(code.charCodeAt(0)+code.length);
  	//  	for(let i = 1;i < code.length; i++) {
  	//    c += String.fromCharCode(code.charCodeAt(i) + code.charCodeAt(i - 1));
  	//  	}
  	//  	return escape(c);
  		return code;
  	}

  	Vue.prototype.unecption = function(code){
  		// code = unescape(code);
  	  // let c = String.fromCharCode(code.charCodeAt(0) - code.length);
  	  // for(let i = 1; i < code.length; i++) {
  	  //  c += String.fromCharCode(code.charCodeAt(i) - c.charCodeAt(i - 1));
  	  // }
  	  // return c;
  		return code;
  	}

    Vue.prototype.toYuan = function(num, length = 2){
      if (typeof num == 'string') {
        return (Number(num) / 100).toFixed(length);
      } else if (typeof num == 'number') {
        return Number(num / 100).toFixed(length);
      }
  	}

    Vue.prototype.toCent = function(num){
      if (typeof num == 'string') {
        return +parseFloat((Number(num) * 100).toPrecision(12));
      } else if (typeof num == 'number') {
        return +parseFloat((num * 100).toPrecision(12));
      }
  	}

    Vue.prototype.openNewPage = function(link){
      const tempwindow = window.open('_blank'); // 先打开页面
      tempwindow.location = link; // 后更改页面地址
  	}

    Vue.prototype.openNewPageByName = function(name, params){
      const { href } = this.$router.resolve({ name, params });
      if (this.isWeixinBrowser()) {
        window.open(href);
      } else {
        // window.open(href, '_blank');
        const tempwindow = window.open('_blank'); // 先打开页面
        tempwindow.location = href; // 后更改页面地址
      }
  	}

    Vue.prototype.isWeixinBrowser = function(){
      var ua = navigator.userAgent.toLowerCase();
      var isWeixin = ua.indexOf('micromessenger') != -1;
      if (isWeixin) {
        return true;
      } else {
        return false;
      }
  	}

    Vue.prototype.isShowTip = function(name) {
      if (localStorage.getItem('tipShowMap')) {
        let tipShowMap = JSON.parse(this.unecption(localStorage.getItem('tipShowMap')))
        if (tipShowMap.hasOwnProperty(name) && tipShowMap[name] == 1) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
  	}

    Vue.prototype.disShowTip = function(name) {
      let tipShowMap = {};
      if (localStorage.getItem('tipShowMap')) {
        tipShowMap = JSON.parse(this.unecption(localStorage.getItem('tipShowMap')))
      }
      tipShowMap[name] = 1;
      localStorage.setItem('tipShowMap', this.ecption(JSON.stringify(tipShowMap)));
  	}

  	//帮助文档链接
  	Vue.prototype.getHelpHost = function(pageId){
      return help.host + '/web/#/2?page_id=' + pageId;
  	}

  	//列表表头tipicon渲染
  	Vue.prototype.tipRenderHeader = function(h, obj, name, content){
      return h('div', {
  			class: 'flex',
  			style: 'background-color: transparent'
  		}, [
  			[name],
  			h('el-tooltip', {
  				style: 'background-color: transparent; margin-top: -1.5px;',
  				attrs: {
  					effect: 'light',
  					content,
  					placement: 'right'
  				}
  			}, [
  				h('div', {
  					class: 'question-tip-icon'
  				}),
  			])
  		])
  	}

    Vue.prototype.isArray = function(val){
      if (typeof Array.isArray === "function") {
        return Array.isArray(val);
      } else {
        return Object.prototype.toString.call(val) === "[object Array]";
      }
  	}

    Vue.prototype.randomNum = function(len){
      var salt = '';
    	for( var i=0; i<len; i++ ){
    	  	var tmp = parseInt( Math.floor( Math.random() * 10 ) );
    	  	if( !tmp ){
    	  		tmp = '2';
    	  	}
    	  	salt += tmp;
    	  }
    	 return salt;
  	}

  	String.prototype.toTrim = function () {
  		// return x.replace(/^\s+|\s+$/gm,'');
  		return this.replace(/(^\s*)|(\s*$)/g, "");
  	}
  	String.prototype.startWith = function (str) {
  		var reg = new RegExp("^" + str);
  		return reg.test(this);
  	}
  	// 直接使用str.endWith("abc")方式调用即可
  	String.prototype.endWith = function (str) {
  		var reg = new RegExp(str + "$");
  		return reg.test(this);
  	}

  	String.prototype.replaceAll = function(s1, s2){
  		return this.replace(new RegExp(s1,"gm"),s2);
  	}

  	String.prototype.toSimpleText = function(){
      var re1 = new RegExp("<.+?>","g"); // 匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
      var msg = this.replace(re1,''); // 执行替换成空字符
      return msg;
  	}

    // 元单位转为分
    // https://blog.csdn.net/myc_315191545/article/details/78191269
  	String.prototype.toCent = function(){
      if (typeof this == 'string') {
        // return (Number(this) * 100).toFixed(2);
        return +parseFloat((Number(this) * 100).toPrecision(12));
      } else if (typeof this == 'number') {
        // return (this * 100).toFixed(2);
        return +parseFloat((this * 100).toPrecision(12));
      }
      return this;
  	}
  }
};



// WEBPACK FOOTER //
// ./src/utils/base.js